import { render } from "./WithdrawalMethodModal.vue?vue&type=template&id=053dfb04"
import script from "./WithdrawalMethodModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalMethodModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__